export const state = {
    ga_enabled: false,
    website_enabled: false,
    unsaved_changes: false,
    all_settings: null,
    is_publishing: false,
};

export default state;
